import { Action } from "redux";

export const CANCEL_SUBSCRIPTION_FOR_USER_FAIL =
  "SUBSCRIPTION:CANCEL_SUBSCRIPTION_FOR_USER_FAIL";

export interface CancelSubscriptionForUserFail extends Action {
  type: typeof CANCEL_SUBSCRIPTION_FOR_USER_FAIL;
  organizationKeyName: string;
  userId: number;
  subscriptionId: string;
}

export const cancelSubscriptionForUserFail = (
  organizationKeyName: string,
  userId: number,
  subscriptionId: string
): CancelSubscriptionForUserFail => ({
  type: CANCEL_SUBSCRIPTION_FOR_USER_FAIL,
  organizationKeyName,
  userId,
  subscriptionId,
});
